import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IDownloadAgendasPayload {
    participants?: any
    companies?: any
    meetingDate?: string
    status?: string[]
    meetingType?: string[]
    sagaCB: {
        onSuccess: any
    }
}

export interface IState {
    status: string
    data: any
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const downloadAgendasSlice = createSlice({
    name: 'reporting/download-agendas',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IDownloadAgendasPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const downloadAgendasActions = downloadAgendasSlice.actions
export default downloadAgendasSlice.reducer
